import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { TextareaModule } from 'primeng/textarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { TabsModule } from 'primeng/tabs';
import { SkeletonModule } from 'primeng/skeleton';
import { ChipModule } from 'primeng/chip';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { ToolbarModule } from 'primeng/toolbar';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef
} from 'primeng/dynamicdialog';

import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';

import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ChartModule } from 'primeng/chart';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ScrollerModule } from 'primeng/scroller';

@NgModule({
  declarations: [],
  imports: [
    ButtonModule,
    CardModule,
    TableModule,
    SelectModule,
    DividerModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    CheckboxModule,
    DialogModule,
    ProgressBarModule,
    TextareaModule,
    ProgressSpinnerModule,
    ToastModule,
    TabsModule,
    SkeletonModule,
    ChipModule,
    MultiSelectModule,
    AccordionModule,
    PopoverModule,
    TooltipModule,
    FileUploadModule,
    DatePickerModule,
    RadioButtonModule,
    ToggleSwitchModule,
    ChartModule,
    BlockUIModule,
    PanelModule,
    AutoCompleteModule,
    TagModule,
    ToolbarModule,
    MenuModule,
    ConfirmPopupModule,
    ScrollerModule
  ],
  exports: [
    ButtonModule,
    CardModule,
    TableModule,
    SelectModule,
    DividerModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    CheckboxModule,
    DialogModule,
    ProgressBarModule,
    TextareaModule,
    ProgressSpinnerModule,
    ToastModule,
    TabsModule,
    SkeletonModule,
    ChipModule,
    MultiSelectModule,
    AccordionModule,
    PopoverModule,
    TooltipModule,
    FileUploadModule,
    DatePickerModule,
    RadioButtonModule,
    ToggleSwitchModule,
    ChartModule,
    BlockUIModule,
    PanelModule,
    AutoCompleteModule,
    TagModule,
    ToolbarModule,
    MenuModule,
    ConfirmPopupModule,
    ScrollerModule
  ],
  providers: [DialogService, DynamicDialogConfig, DynamicDialogRef]
})
export class PrimengExportsModule {}
